<script setup lang="ts">
import { BListItem, BIcon } from '@/design-system';
import type { ConditionOperatorType } from '@/types/HookConditionTypes';

defineProps<{
    itemProps: Record<string, unknown>;
    operator: ConditionOperatorType;
}>();
</script>

<template>
    <BListItem
        v-bind="itemProps"
        class="operator-item"
        density="compact"
    >
        <template #title>
            <div class="d-flex align-center justify-space-between w-100">
                <BIcon
                    size="18"
                    class="mr-4"
                >{{ operator.symbol }}</BIcon
                >
                <span class="text-grey-600 operator-name">{{ operator.name }}</span>
            </div>
        </template>
    </BListItem>
</template>

<style scoped>
.operator-item {
    .operator-name {
        font-size: 12px;
        text-transform: uppercase;
    }
}
</style>
